const { appLinkTypeEnum, notificationStatusEnum } = require('@/airModels/types/notificationModel')
const m = require('air-vue-model')()
m.url = 'notifications'
m.name = 'notification'

m.text = {
  itemTitle: 'PUSH уведомление',
  listTitle: 'PUSH уведомления'
}

m.appLinkTypeEnum = appLinkTypeEnum // use in subject_type

// m.appLinkTypeEnum = { // use in subject_type
//   EXTERNAL_LINK: 'external_link',
//   APP_BONUSES_PAGE: 'app_bonuses_page',
//   APP_PROMO_PAGE: 'app_promo_page',
//   APP_PRODUCT_PAGE: 'app_product_page',
// }

m.appLinkTitle = {
  [m.appLinkTypeEnum.EXTERNAL_LINK]: 'Внешняя ссылка',
  [m.appLinkTypeEnum.APP_BONUSES_PAGE]: 'Страница бонусов',
  [m.appLinkTypeEnum.APP_PROMO_PAGE]: 'Страница акции',
  [m.appLinkTypeEnum.APP_PRODUCT_PAGE]: 'Страница блюда'
}

m.appLinks = Object.keys(m.appLinkTitle).map(key => {
  return {
    label: m.appLinkTitle[key],
    value: key
  }
})

m.default = {
  title: null,
  body: null,
  status: notificationStatusEnum.CREATED,
  notification_type: 'other',
  subject_id: null,
  subject_type: null,
  external_link: null,
  send_date: null,
  force: false,
  send_batch_size: null,
  participant_filters: {},
  accept_button_text: null
}

m.getParticipantFilters = (filters) => {
  const removeEmpty = (value) => {
    if (Array.isArray(value)) {
      const filteredArr = value
        .map(item => removeEmpty(item))
        .filter(item => item !== undefined);
      return filteredArr.length ? filteredArr : undefined;
    }
    
    if (value && typeof value === 'object') {
      const obj = {};
      let isEmpty = true;
      
      for (const key in value) {
        const result = removeEmpty(value[key]);
        if (result !== undefined) {
          obj[key] = result;
          isEmpty = false;
        }
      }
      
      return isEmpty ? undefined : obj;
    }
    
    if (value === null || value === undefined || value === '') {
      return undefined;
    }
    
    return value;
  };

  const result = removeEmpty(filters);
  
  if (result.areas && !result.areas.items) result.areas = undefined
  const startAge = result.start_age
  const endAge = result.end_age
  if (startAge && startAge < 0) result.start_age = undefined
  if (endAge && endAge < 0) result.end_age = undefined
  const orderItemGroups = result.order_item_groups || []
  const validatedOrderItemGroups = orderItemGroups.filter(group => group.items?.length && group.orders_count)
  result.order_item_groups = validatedOrderItemGroups.length ? validatedOrderItemGroups : undefined
  return result || {};
}

module.exports = m
